import clsx from "clsx";

export function MentionUserAvatar(props: {
	name: string;
	avatarUrl?: string | null;
	size?: "xs" | "sm" | "md";
}) {
	const { name, avatarUrl, size = "sm" } = props;
	const sizeClass =
		size === "xs" ? "size-3.5" : size === "md" ? "size-8" : "size-6";
	const textClass =
		size === "xs"
			? "text-[9px] font-bold"
			: size === "md"
				? "text-xs font-semibold"
				: "text-xs font-semibold";

	if (avatarUrl) {
		return (
			<img
				alt=""
				aria-hidden="true"
				className={clsx(sizeClass, "rounded-full object-cover shrink-0")}
				src={avatarUrl}
			/>
		);
	}

	const initial = (name.trim().charAt(0) || "?").toUpperCase();
	return (
		<div
			aria-hidden="true"
			className={clsx(
				"flex shrink-0 items-center justify-center rounded-full",
				"bg-brand-primary text-white",
				sizeClass,
				textClass,
			)}
		>
			{initial}
		</div>
	);
}
